<template>
  <div class="cursor-pointer w-full h-full" :id="domId" @click="getImage">
    <div
      ref="imgRef"
      class="w-72 h-72 bg-gray-245 blob-canvas mx-auto relative overflow-hidden"
      :style="containerStyle"
    >
      <blob
        :gradient="gradient"
        :gradientId="gradientId"
        :key="i"
        v-for="i in count"
      />
    </div>
  </div>
</template>

<script>
import Blob from "./Blob";

import { getRandomInt } from "../util/common.util";
import domtoimage from "dom-to-image";
import { saveAs } from "file-saver";

export default {
  name: "blobber",
  components: {
    Blob,
  },
  props: {
    gradient: Array,
  },
  data() {
    return {
      // gradient: gradients[getRandomInt(0, gradients.length)].colors,
      count: 15,
      circleCount: 4,
      gradientId: getRandomInt(100000, 500000),
      domId: getRandomInt(500000, 800000),
      circleStyle: {
        left: getRandomInt(-20, 100) + "%",
        top: getRandomInt(-20, 100) + "%",
        transform: `rotateZ(${getRandomInt(0, 360)}deg)`,
      },
    };
  },
  computed: {
    containerStyle: function () {
      return {
        background: `linear-gradient(${this.getRandomInt(0, 360)}deg, ${
          this.gradient[0]
        }, ${this.gradient[1]})`,
      };
    },
  },

  methods: {
    getCircleStyle: function () {
      let circleSize = getRandomInt(2, 10);
      return {
        left: getRandomInt(-20, 100) + "%",
        top: getRandomInt(-20, 100) + "%",
        transform: `rotateZ(${getRandomInt(0, 360)}deg)`,
        width: `${circleSize}%`,
        height: `${circleSize}%`,
      };
    },
    getRandomInt,
    getImage: function () {
      let img = document.getElementById(this.domId);

      let childNode = img.childNodes[0];

      let childHeight = childNode.style.height;
      let childWidth = childNode.style.width;

      childNode.style.width = "1400px";
      childNode.style.height = "1800px";

      domtoimage.toBlob(img).then((blob) => {
        childNode.style.width = childWidth;
        childNode.style.height = childHeight;
        saveAs(blob, `wallpaper-${this.domId}`);
      });
    },
  },
};
</script>

<style scoped>
.blob-canvas {
  width: 50%;
  height: calc(70% - 142px);
}

@media screen and (min-width: 768px) {
  .blob-canvas {
    width: 48%;
    height: calc(68% - 157.5px);
  }
}

/* @media screen and (min-width: 800px) {
  .blob-canvas {
    width: 48%;
    height: 52%;
  }
}

@media screen and (min-width: 880px) {
  .blob-canvas {
    width: 48%;
    height: 42%;
  }
}

*/
/* @media screen and (min-width: 1100px) {
  .blob-canvas {
    width: 48%;
    height: calc(75% - 214px);
  }
}  */
</style>